import React from 'react';
import { connect } from 'react-redux';

import { updateGlove } from '../../actions/creators';
import syncPreview from '../higher-order/SyncPreview';
import CustomPythonButtons from '../CustomPythonButtons';

const Thumb = ({
  customPythons,
  insideCurrentCustomPython,
  onInsideCustomPythonClick,
  outsideCurrentCustomPython,
  onOutsideCustomPythonClick,
}) => (
  <div className="step-item-view-wrap pull-right">
    <CustomPythonButtons
      title="THUMB INSIDE COLOR"
      className="finger-inside-color-wrap"
      images={customPythons}
      currentCustomImage={insideCurrentCustomPython}
      onClick={onInsideCustomPythonClick}
    />
    <CustomPythonButtons
      title="THUMB OUTSIDE COLOR"
      className="finger-outside-color-wrap"
      images={customPythons}
      currentCustomImage={outsideCurrentCustomPython}
      onClick={onOutsideCustomPythonClick}
    />
  </div>
);

const mapStateToProps = (state) => {
  const { thumbInsidePython, thumbOutsidePython } = state.glove;

  return {
    customPythons: state.builder.leatherColors[state.glove.leatherGrade.id],
    insideCurrentCustomPython: thumbInsidePython,
    outsideCurrentCustomPython: thumbOutsidePython,
  };
};

const mapDispatchToProps = dispatch => ({
  onInsideCustomPythonClick: python => dispatch(updateGlove({ thumbInsidePython: python })),
  onOutsideCustomPythonClick: python => dispatch(updateGlove({ thumbOutsidePython: python })),
});

export default syncPreview(connect(
  mapStateToProps,
  mapDispatchToProps,
)(Thumb), 'webSide');
